<template>
    <aside :class="[isShown ? 'shown' : 'hidden', isLight ? 'lightmode' : 'darkmode']">
        <div id="website-controls">
            <button :class="[isLight ? 'lightmode' : 'darkmode']" @click="changeTheme">☼</button>
            <button id="show-sidebar" :class="[isLight ? 'lightmode' : 'darkmode']" @click="toggleMenuMobile">☰</button>
        </div>
        <h4 :class="[isLight ? 'lightmode' : 'darkmode']">Tools</h4>
        <button @click="changeCalc(1)" :class="[isLight ? 'lightmode' : 'darkmode',selectedIndex == 1 ? 'selected' : '']">Time calculations</button>
        <button @click="changeCalc(2)" :class="[isLight ? 'lightmode' : 'darkmode',selectedIndex == 2 ? 'selected' : '']">Calendar conversions</button>
        <button @click="changeCalc(3)" :class="[isLight ? 'lightmode' : 'darkmode',selectedIndex == 3 ? 'selected' : '']">Timezone conversions</button>
        <button @click="changeCalc(4)" :class="[isLight ? 'lightmode' : 'darkmode',selectedIndex == 4 ? 'selected' : '']">Convert units of time</button>
        <h4 :class="[isLight ? 'lightmode' : 'darkmode']">About</h4>
        <button @click="changeCalc(5)" :class="[isLight ? 'lightmode' : 'darkmode',selectedIndex == 5 ? 'selected' : '']">About Time Calculator</button>
        <button @click="changeCalc(6)" :class="[isLight ? 'lightmode' : 'darkmode',selectedIndex == 6 ? 'selected' : '']">Untitled 9</button>
    </aside>
</template>

<script setup>
    import { defineEmits,defineProps,toRef } from "vue";
    import { useRouter } from "vue-router";

    const props = defineProps({
        menuShown:Boolean,
        darkMode:Boolean,
        selectedCalc:Number
    });

    const emit = defineEmits(['change-theme','toggle-menu-mobile','change-calc']);

    var isShown = toRef(props,'menuShown');
    var isLight = toRef(props,'darkMode');
    var selectedIndex = toRef(props,'selectedCalc');
    const router = useRouter();

    const changeTheme = () => 
    {
        isLight.value = !isLight.value;
        emit('change-theme');
    };

    const toggleMenuMobile = () =>
    {
        isShown.value = !isShown.value;
        emit('toggle-menu-mobile');
    };

    const changeCalc = (a) =>
    {
        switch(a)
        {
            case 1:
            {
                router.push('/simple-calculator');
                break;
            }

            case 2:
            {
                router.push('/calendar-converter');
                break;
            }

            case 3:
            {
                router.push('/timezone-converter');
                break;
            }

            case 4:
            {
                router.push('/unit-converter');
                break;
            }

            case 5:
            {
                router.push('/about');
                break;
            }

            case 6:
            {
                router.push('/untitled-9');
                break;
            }

            default:
            {
                router.push('/');
                break;
            }
        }
    }
</script>

<style scoped>
    aside
    {
        height: 100dvh;
        width:280px;
        max-width: 100%;
        z-index:9;
        display:flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items:flex-start;
        top:0;
        right:0;
        position:fixed;
        gap:10px;
        padding:6px 12px;
        overflow: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;
        box-sizing: border-box;
    }

    aside::-webkit-scrollbar
    {
        display: none;
    }

    aside h4
    {
        font-family: Syne;
        margin:0;
        cursor: default;
        user-select: none;
    }

    #website-controls
    {
        display:flex;
        flex-direction: row;
        justify-content:flex-end;
        align-items: center;
        align-self:flex-end;
        padding:0 5px;
        width:69%;
        height:45px;
    }

    aside.lightmode
    {
        background-color: #F7F7F6;
        border-right:2px solid #BAB8B9;
        color: #2b3133;
    }

    aside.darkmode
    {
        background-color: #2b3133;
        border-right:2px solid #F7F7F6;
        color: #F7F7F6;
    }

    button
    {
        cursor:pointer;
    }

    #website-controls button
    {
        width:45px;
        height:45px;
        font-size:30px;
    }

    aside button
    {
        font-family:Syne;
        font-size:clamp(8px,8vw,24px);
        border:none;
        border-radius:6px;
        background-color:#11111100;
    }

    aside button.selected
    {
        font-weight: bold;
    }

    aside button.lightmode
    {
        color: #2b3133;
    }

    aside button.darkmode
    {
        color: #F7F7F6;
    }

    aside button:hover
    {
        background-color: #BAB8B9ff;
    }

    .hidden
    {
        transform: translateX(280px);
    }

    .shown
    {
        transform: translateX(0);
        justify-self:right;
    }

    @media screen and (min-width: 770px)
    {
        #website-controls
        {
            display:none;
        }

        aside.shown,aside.hidden
        {
            display:none;
        }
    }
</style>